import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { DesigningService } from '../designing.service';
import { TranslateService } from '@ngx-translate/core';
import { FirebaseService } from 'app/services/firebase.service';
import * as fromApp from '../../../app.reducer';
import * as fromNew from '../../new/store/new.reducer';
import { Store } from '@ngrx/store';

@Component({
  selector: 'designing-progress',
  styleUrls: ['../designing.component.scss', './progress.component.scss'],
  templateUrl: './progress.component.html',
})
export class DesigningProgressComponent implements OnInit, OnDestroy {
  @Input() step;
  @Input() totalSteps;
  @Output() next = new EventEmitter();
  @Output() prev = new EventEmitter();
  uploadStatus: fromNew.State;

  thumbnailPercent = 0;
  highResPercent = 0;
  globalProgress;

  increasingTimer = 1000;

  waitingTimer = 60000;

  constructor(
    private firebaseService: FirebaseService,
    public designingService: DesigningService,
    public translate: TranslateService,
    private store: Store<fromApp.AppState>,
  ) {}

  ngOnInit() {
    this.designingService.isUploadProgressShowing = true;
    if (this.designingService.designingProgress === 100) {
      this.designingService.navigateToBook();
    } else {
      this.firebaseService.logEvent('design_request_wait_design_in_progress');
      setTimeout(() => {
        this.firebaseService.logEvent('design_request_too_long_to_wait');
      }, this.waitingTimer);
    }
    this.store.select('new').subscribe(storyUploading => {
      this.uploadStatus = storyUploading;
      if (this.uploadStatus.uploadStatus.thumbnailPercent !== -1) {
        this.thumbnailPercent = Math.round(this.uploadStatus.uploadStatus.thumbnailPercent / 4);
      } else {
        this.thumbnailPercent = 25;
      }
      if (this.uploadStatus.uploadStatus.progressPercent !== -1) {
        this.highResPercent = Math.round(this.uploadStatus.uploadStatus.progressPercent / 4);
      } else {
        this.highResPercent = 25;
      }
    });
  }

  ngOnDestroy() {
    this.designingService.isUploadProgressShowing = false;
    this.designingService.designingProgress = 0;
  }


  submit() {
    this.next.emit();
  }
}
